(function () {
  // Função para inicializar acordeões no mobile
  function initMobileAccordions() {
    const blockTitles = document.querySelectorAll(".footer__block-title");

    if (blockTitles.length === 0) {
      return; // Elementos ainda não foram renderizados
    }

    const isMobile = window.matchMedia("(max-width: 1024px)").matches;

    blockTitles.forEach(function (title, index) {
      // Pular newsletter e logo - elas não devem ter acordeão
      const block = title.closest(".footer__block");
      if (
        block &&
        (block.dataset.blockType === "newsletter" ||
          block.dataset.blockType === "logo")
      ) {
        return; // Newsletter e logo não têm acordeão
      }

      // Garantir que o cursor seja pointer no mobile
      if (isMobile) {
        title.style.cursor = "pointer";
        title.style.pointerEvents = "auto";
      }

      // Remover event listeners anteriores usando uma flag
      if (title.dataset.accordionInitialized === "true") {
        return; // Já foi inicializado
      }
      title.dataset.accordionInitialized = "true";

      // Adicionar event listener de click apenas no mobile
      if (isMobile) {
        // Função para alternar o accordion
        const toggleAccordion = function (e) {
          // Se o click foi em um link dentro do conteúdo, deixar o link funcionar
          if (e.target.tagName === 'A' || e.target.closest('a')) {
            // Se o link está dentro do conteúdo aberto, deixar funcionar normalmente
            const content = title.nextElementSibling;
            if (content && content.classList.contains("active") && content.contains(e.target)) {
              return; // Deixar o link funcionar
            }
            // Se o link está no título ou fora do conteúdo, alternar o accordion
          }
          
          e.preventDefault();
          e.stopPropagation();

          const isActive = title.classList.contains("active");
          const content = title.nextElementSibling;

          // Fechar todos os outros blocos
          blockTitles.forEach(
            function (otherTitle) {
              if (otherTitle !== title) {
                otherTitle.classList.remove("active");
                otherTitle.setAttribute("aria-expanded", "false");
                const otherContent = otherTitle.nextElementSibling;
                if (
                  otherContent &&
                  otherContent.classList.contains("footer__block-content")
                ) {
                  otherContent.classList.remove("active");
                }
              }
            }
          );

          // Alternar o bloco atual
          if (isActive) {
            title.classList.remove("active");
            title.setAttribute("aria-expanded", "false");
            if (content) {
              content.classList.remove("active");
            }
          } else {
            title.classList.add("active");
            title.setAttribute("aria-expanded", "true");
            if (content) {
              content.classList.add("active");
            }
          }
        };

        // Adicionar evento no bloco inteiro
        if (block) {
          block.addEventListener("click", function(e) {
            // Se o click foi em um link dentro do conteúdo aberto, deixar funcionar
            const content = title.nextElementSibling;
            if (content && content.classList.contains("active") && content.contains(e.target) && (e.target.tagName === 'A' || e.target.closest('a'))) {
              return; // Deixar o link funcionar normalmente
            }
            // Caso contrário, alternar o accordion
            toggleAccordion(e);
          }, false);
        }
        
        // Manter evento no título também para compatibilidade
        title.addEventListener("click", toggleAccordion, false);

        // Suporte a teclado
        title.addEventListener(
          "keydown",
          function (e) {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              this.click();
            }
          },
          false
        );
      }
    });
  }

  // Executar quando o DOM estiver pronto
  function runInit() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        setTimeout(initMobileAccordions, 100);
      });
    } else {
      setTimeout(initMobileAccordions, 100);
    }
  }

  runInit();

  // Re-executar em caso de redimensionamento
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      // Resetar flags para re-inicializar
      document
        .querySelectorAll(".footer__block-title")
        .forEach(function (title) {
          title.dataset.accordionInitialized = "false";
        });
      initMobileAccordions();
    }, 250);
  });

  // Fallback: tentar novamente após um pequeno delay
  setTimeout(initMobileAccordions, 500);
})();
